import React from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { MasonryColumns } from "./MasonryColumn";
import { Button } from "@/components/ui/button";
import { IconX } from "@tabler/icons-react";

interface Props<T> {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  items: T[];
  renderItem: (item: T, index: number) => React.ReactNode;
  cardWidth?: number;
  cardGap?: number;
  maxColumns?: number;
  showCloseButton?: boolean;
}

function GalleryView<T>({
  open,
  onOpenChange,
  items,
  renderItem,
  cardWidth = 295,
  cardGap = 14,
  maxColumns = 4,
  showCloseButton = false,
}: Props<T>) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange} modal={true}>
      <DialogContent
        className="p-0 w-full max-w-full h-full max-h-full overflow-hidden bg-transparent border-0 outline-none shadow-none duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95"
        hideCloseButton
        onClick={() => onOpenChange(false)}
        // to handle inner text area inside ad preview
        onFocus={(e) => e.stopPropagation()}
      >
        <div className="w-full h-full p-12 overflow-y-auto scrollbar-hide">
          <MasonryColumns
            items={items}
            cardWidth={cardWidth}
            cardGap={cardGap}
            centerAlignColumns
            maxColumns={maxColumns}
            renderItem={(item, index) => (
              <div onClick={(e) => e.stopPropagation()}>{renderItem(item, index)}</div>
            )}
          />
        </div>
        {showCloseButton && (
          <div className="fixed right-[10px] top-[8px] z-10">
            <Button
              variant={"outline"}
              size={"icon"}
              onClick={() => onOpenChange(false)}
              className="group hover:bg-white"
            >
              <IconX
                size={14}
                className="text-brand-primary-400 group-hover:text-[#E81616]"
              />
            </Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default GalleryView;
